export default __webpack_public_path__ + "static/media/Banner2022_Indian-min.93ae049f.png";